// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StarX from "@insite/mobius/Icons/StarX";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { productPriceStyles } from "@steiner/Overrides/Components/ProductPrice";
import InfoTooltip from "@steiner/XDL/Icons/InfoTooltip";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { color, mergeWithCss } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

const sharedPriceStyle: TypographyPresentationProps = {
    size: 16,
    lineHeight: "22px",
    weight: fontConfig.weight.semiBold,
    color: "primary",
};
productPriceStyles.price = {
    priceText: {
        ...sharedPriceStyle,
        css: css`
            margin-right: 4px;

             ${({ isPriceNotAvailable }: any) => {
                if (isPriceNotAvailable) {
                    return css`
                        font-weight: 400;
                        font-size: 15px;
                        color: ${color("text")};
                    `;
                }
            }}
        `,
    },
    unitOfMeasure: {
        unitOfMeasureText: {
            ...sharedPriceStyle,
        },
    },
    realTimeText: {
        color: "primary",
        weight: "bold",
        css: css`
            display: inline-block;
            text-align: left;
            min-width: 25px;

            &::after {
                overflow: hidden;
                display: inline-block;
                vertical-align: bottom;
                animation: ellipsis steps(4, end) 900ms infinite 1s;
                content: "\\2026";
                width: 0;
            }

            @keyframes ellipsis {
                to {
                    width: 1.25em;
                }
            }
        `,
    },
    uomPrice: {
        priceText: {
            ...mergeWithCss(sharedPriceStyle, {
                css: css`
                    margin-left: 5px;
                `,
            }),
            color: "text.main",
        },
    },
};

productPriceStyles.uomPrice = {
    priceText: {
        ...sharedPriceStyle,
    },
};

productPriceStyles.promoWrapper = {
    css: css`
        display: flex;
        align-items: center;
        padding-inline: 4px;
    `,
};

productPriceStyles.promoIcon = {
    src: StarX,
    size: 14,
    color: "common.ui1",
    css: css`
        path {
            fill: ${color("common.ui3")};
        }
    `,
};

productPriceStyles.promoText = {
    size: 14,
    lineHeight: "14px",
    css: css`
        padding: 4px;
    `,
};
productPriceStyles.quoteMessage = {
    tooltip: {
        mergeCss: true,
        typographyProps: {
            css: css`
                font-size: 12px;
                line-height: 16px;
            `,
        },
        cssOverrides: {
            tooltipClickable: css`
                margin: 0;
            `,
        },
        iconProps: {
            src: InfoTooltip,
            size: 14,
            color: "common.ui8",
            css: css`
                margin-right: 6px;
                vertical-align: middle;
            `,
        },
    },
    text: {
        css: css`
            margin-right: 6px;
        `,
    },
};
